import { makeStyles } from '@mui/styles';
import { padding } from '@mui/system';

export const useStyles = makeStyles({
  textField: {
    width: '100%',
    marginTop: '0.625rem !important',
    marginBottom: '0.5rem',
  },
});
